import React from 'react';
import { PhoneCall, ArrowRight } from 'lucide-react';

export default function AboutCTA() {
  return (
    <div className="bg-[#1E4363] p-8 rounded-sm shadow-xl text-white relative overflow-hidden">
      {/* Decorative background accent */}
      <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-white/5 rounded-full blur-2xl pointer-events-none"></div>

      <h3 className="text-xl font-bold text-white font-serif mb-3 flex items-center gap-3 relative z-10">
        <PhoneCall size={20} className="text-[#87412A]" /> Ready to Collaborate?
      </h3>
      <p className="text-[#F9F8F3]/80 text-sm leading-relaxed mb-6 relative z-10">
        Need expert oversight for an upcoming voyage, vetting inspection, or cargo loading? Reach out directly to discuss your specific maritime requirements with our team.
      </p>
      
      {/* Link to your Contact route */}
      <a href="/contact" className="relative z-10 inline-flex items-center justify-center w-full bg-[#87412A] hover:bg-[#6b3321] text-white py-3.5 px-4 rounded-sm transition-colors duration-300 text-sm font-bold tracking-wider group shadow-md hover:shadow-lg">
        GET IN TOUCH
        <ArrowRight size={16} className="ml-2 transform group-hover:translate-x-1 transition-transform" />
      </a>
    </div>
  );
}